var unsubscribe = function(){	
	var form = new forms4i();
	var unsubscribeForm = document.getElementById("unsubscribeForm"),
	btnSubmit = document.getElementById("btnSubmit"),

	submitForm = function (e) {
		e.preventDefault();
		form.formValidation(unsubscribeForm, submitUnsubscribeForm, e);
	},
	submitUnsubscribeForm = async function(){
		var accountCode = document.getElementById("AccountCode");
		var zipCode = document.getElementById("ZipCode");
		var userName = document.getElementById("Name");
		
		if (accountCode.value.charAt(0).toUpperCase() == "C" && userName.value.length == 0) {
			// User is a customer, show name field and hide the other fields
			var nameGroup = document.getElementById("nameGroup");
			var accountCodeGroup = document.getElementById("accountCodeGroup");
			var zipCodeGroup = document.getElementById("zipCodeGroup");
			
			nameGroup.classList.remove("hide");
			nameGroup.hidden = false;
			userName.classList.add("txtReq");
			userName.setAttribute("aria-required", "true");
			
			accountCodeGroup.classList.add("hide");
			accountCodeGroup.hidden = false;
			accountCode.classList.remove("txtReq");
			accountCode.setAttribute("aria-required", "false");
			
			zipCodeGroup.classList.add("hide");
			zipCodeGroup.hidden = true;
			zipCode.classList.remove("txtReq");
			zipCode.setAttribute("aria-required", "false");
		} else {
			// Either user is a customer, or the name has already been filled in, check recaptcha and submit form
			var recaptchaSiteKey = document.getElementsByClassName("recaptchaSiteKey")[0].value;
			var recaptchaActionName = document.getElementsByClassName("recaptchaActionName")[0].value;
			let verificationToken = document.getElementsByName("__RequestVerificationToken")[0].value;
			
			// Check if grecaptcha is defined
			// if not, try to fetch the script again 
			if(typeof grecaptcha == "undefined" && typeof get4iRecaptcha !== "undefined") await get4iRecaptcha();
			
			// need to show an error if recaptcha script still isn't available
			if(typeof grecaptcha == "undefined"){
				showError();
			}else{
				grecaptcha.execute(recaptchaSiteKey, {action: recaptchaActionName}).then(function(token) {
					var unsubscribeData = {
						accountCode : accountCode.value,
						zipCode : zipCode.value,
						userName : userName.value,
						recaptchaToken : token
					};
						        			
					fetch('/unsubscribe/submit', { 
						method: 'POST', 
						body: JSON.stringify(unsubscribeData), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function(response){
						return  (response.ok) ? response.json() : []; // response.json() returns a promise
					}).then(function(response){
						// hide form and show result
						var resultHeading = document.getElementById("resultHeading");
						var resultInfo = document.getElementById("resultInfo");
						//var resultMoreInfo = document.getElementById("resultMoreInfo");
						
						resultHeading.innerHTML = response.heading;
						resultInfo.innerHTML = response.info;
						//if (response.moreInfo) {
						//	resultMoreInfo.innerHTML = response.moreInfo;
						//}
						
						unsubscribeForm.classList.add("hide");
						unsubscribeForm.hidden = true;
						resultHeading.classList.remove("hide");
						resultHeading.hidden = false;
						document.getElementById("result").classList.remove("hide");
						document.getElementById("result").hidden = false;
					}).catch(function(error){
						showError();
					});
				});
			}
		}
	},
	
	showError = () => {
		// hide form and show error message
		var resultHeading = document.getElementById("resultHeading");
		var resultInfo = document.getElementById("resultInfo");
		
		resultHeading.innerHTML = "Oops!";
		resultInfo.innerHTML = "We were unable to unsubscribe you from 4imprint catalogs and mailings. Please try again later or call us toll free at 1-877-520-2006.";
		
		unsubscribeForm.classList.add("hide");
		unsubscribeForm.hidden = true;
		document.getElementById("result").classList.remove("hide");
		document.getElementById("result").hidden = false;
	},
	init = function(){
		btnSubmit.addEventListener("click", submitForm);
		
		// Clear all fields in case user goes back to form after submitting
		var accountCode = document.getElementById("AccountCode");
		var zipCode = document.getElementById("ZipCode");
		var userName = document.getElementById("Name");
		accountCode.value = "";
		zipCode.value = "";
		userName.value = "";
	};
	
	return {
		Init: init
	};
};
(function(){
	var unsubscribePage = new unsubscribe();
	unsubscribePage.Init();
})();